import React from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';
import { useSound } from '../context/SoundContext';

const SoundToggle = () => {
  const { isMuted, toggleMute, playClick } = useSound();

  const handleToggle = () => {
    toggleMute();
    if (isMuted) {
      // Sound is being turned on, play a sound
      setTimeout(() => {
        playClick();
      }, 50);
    }
  };

  return (
    <motion.button
      onClick={handleToggle}
      className="fixed bottom-6 left-6 w-12 h-12 bg-panel-purple rounded-lg flex items-center justify-center z-50 border-2 border-dark-border hover:border-neon-pink transition-colors group"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{ cursor: 'none' }}
      title={isMuted ? 'Unmute sounds' : 'Mute sounds'}
    >
      {isMuted ? (
        <VolumeX className="w-5 h-5 text-lavender group-hover:text-neon-pink transition-colors" />
      ) : (
        <Volume2 className="w-5 h-5 text-neon-pink" />
      )}

      {/* Pixel decoration */}
      <div className="absolute -top-1 -right-1 w-2 h-2 bg-trophy-gold" />
    </motion.button>
  );
};

export default SoundToggle;
